import { useState, useContext } from 'react';
import { useHistory } from 'react-router-dom';

import { AppContext } from 'commons-ui';

import { UserV2 } from 'models/settingsV2.model';
import useService from '../../utils/useService';
import { FORM_FIELD_CONFIG, FORM_FIELD_KEYS } from '../../helper';
import { getFormDefaults } from './helper';

const useCreate = () => {
	const [showLoader, setShowLoader] = useState(false);
	const { showAlert, app } = useContext(AppContext);
	const {
		requestCreateUser,
		getDepartmentOptions,
		getManagerOptions,
		getDesignationOptions,
		getPermissionSetOptions,
		getPermissionsOptions,
		getTeamOptions,
		getRoleNameTempOptions
	} = useService();
	FORM_FIELD_CONFIG[FORM_FIELD_KEYS.DEPARTMENT].setRenderProps({ getOptions: getDepartmentOptions });
	FORM_FIELD_CONFIG[FORM_FIELD_KEYS.MANAGER].setRenderProps({ getOptions: getManagerOptions });
	FORM_FIELD_CONFIG[FORM_FIELD_KEYS.DESIGNATION].setRenderProps({ getOptions: getDesignationOptions });
	FORM_FIELD_CONFIG[FORM_FIELD_KEYS.PERMISSION_SET].setRenderProps({ getOptions: getPermissionSetOptions });
	FORM_FIELD_CONFIG[FORM_FIELD_KEYS.PERMISSIONS].setRenderProps({ getOptions: getPermissionsOptions });
	FORM_FIELD_CONFIG[FORM_FIELD_KEYS.TEAM].setRenderProps({ getOptions: getTeamOptions });
	FORM_FIELD_CONFIG[FORM_FIELD_KEYS.ROLE_NAME_TEMP].setRenderProps({ getOptions: getRoleNameTempOptions });
	const data = getFormDefaults();

	const history = useHistory();

	const createUser = async (formData: UserV2) => {
		setShowLoader(true);

		try {
			const response = await requestCreateUser(app.appName, formData);
			if (!response?.data?.success) {
				throw new Error(response?.data?.message || 'Failed to create user');
			}
		} catch (err: any) {
			const errorMessage: string = err.response?.data?.error || err?.message;
			showAlert(errorMessage ?? 'Error while creating this user', { type: 'error' });
			setShowLoader(false);

			history.goBack();
			return;
		}
		showAlert('User created successfully', { type: 'success' });
		setShowLoader(false);

		history.goBack();
	};

	const handleFormSubmit = (formData: UserV2) => {
		createUser(formData);
	};

	const handleFormCancel = () => {
		history.goBack();
	};

	return { data, showLoader, handleFormSubmit, handleFormCancel, setShowLoader };
};

export default useCreate;
